'use client';

import { createContext, useContext } from 'react';
import type {
  BaseAppSignalDto,
  GroupedSignal,
} from '@terra/shared-contracts-signals';
import type { SignalsNavigation } from './useSignalsNavigation';

export type SignalsHeaderCheckboxState = boolean | 'indeterminate';

export type SignalsTableContextValue = {
  isRejectedView: boolean;
  isSelectionDisabled: boolean;
  headerCheckboxState: SignalsHeaderCheckboxState;
  isSelectAllDisabled: boolean;
  expandedSignalIds: ReadonlySet<string>;
  boothAttackSignalId: string | undefined;
  navigation: SignalsNavigation;
  isSignalSelected: (signal: GroupedSignal) => boolean;
  onSelectAll: (shouldSelect: boolean) => void;
  onSelectSignal: ({
    signalId,
    shouldSelect,
  }: {
    signalId: string;
    shouldSelect: boolean;
  }) => void;
  onToggleExpanded: (signalId: string) => void;
  onUpdateSignal: (
    signalId: string,
    updates: Partial<BaseAppSignalDto>,
  ) => void;
};

const SignalsTableContext = createContext<SignalsTableContextValue | null>(
  null,
);

export const SignalsTableContextProvider = SignalsTableContext.Provider;

export function useSignalsTableContext(): SignalsTableContextValue {
  const value = useContext(SignalsTableContext);

  if (!value) {
    throw new Error(
      'useSignalsTableContext must be used inside SignalsTableContextProvider',
    );
  }

  return value;
}
